import styled from 'styled-components';
import Slide from '../containers/Slide';
import AccentLine from '../widgets/AccentLine';
import GetEducationList from '../../data/education-list';
import { motion, useInView } from "framer-motion"
import React, { useRef } from 'react';
import SectionHeader from '../widgets/SectionHeader';
import BathroomImage from '../../res/images/bathrooms/img8.jpeg';
import ShowerImage from '../../res/images/bathrooms/img11.jpeg';
import FlooringImage from '../../res/images/flooring/img29.jpeg';
import JonCramer from '../../res/images/jon-cramer.png';
import ElainWatson from '../../res/images/elaine-watson.png';
import MykelGroznik from '../../res/images/mykel-groznik.png';
import QuoteIcon from '../../res/icons/quote.svg';
import FullStarIcon from '../../res/icons/star-full.svg';

const Container = styled.div.attrs({ className: "reviews-slide" })`
    width: 75%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    padding: 0 0 6rem 0;

    #reviews-container {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 2rem;

        h3 {
            color: var(--white);
            font-size: 2.4rem;
            font-weight: normal;
        }

        p {
            box-sizing: border-box;
            font-size: 1.2rem;
            line-height: 1.8rem;
            color: var(--muted);
        }

        & > p {
            border-left: 4px solid var(--yellow);
            padding: 0 1rem;
        }

        .reviews {
            display: grid;
            grid-template-columns: repeat(12, 1fr);
            gap: 2rem;
            margin: 22px 0;

            .review {
                grid-column: span 4;
                background: var(--surface-2);
                border: 1px solid var(--border);
                border-radius: var(--radius-lg);
                overflow: hidden;
                box-shadow: var(--shadow-soft);
                transition: transform .12s ease;
                display: flex;
                flex-direction: column;
                gap: 1rem;
                box-sizing: border-box;
                padding: 2rem;

                .quote-img {
                    width: 60px;
                    height: 60px;
                }

                .star-list {
                    list-style: none;
                    display: flex;
                    align-items: center;
                    margin-bottom: 1rem;
                }

                .star {
                    width: 36px;
                    height: 36px;
                    background-image: url('${FullStarIcon}');
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: contain;
                }

                .quote-text {
                    color: var(--black);
                    font-size: 1.6rem;
                    line-height: 2.4rem;
                    font-weight: bold;
                    margin-bottom: 1rem;
                }

                .profile-container {
                    display: flex;
                    align-items: center;
                    gap: 2rem;

                    img {
                        width: 36px;
                        height: 36px;
                        border-radius: 36px;
                    }
                    
                    h3 {
                        color: var(--black);
                        font-size: 1.4rem;
                    }
                }
            }
        }
    }

    @media screen and (max-width: 980px) {
        height: auto;

        #reviews-container .reviews {
            grid-template-columns: 1fr 1fr 1fr;
        }
    }

    @media screen and (max-width: 650px) {
        height: auto;

        #education-list {
            grid-template-columns: 1fr;
            grid-template-rows: auto;
        }
    }
`

export default function ReviewsSlide() {

    /*
        The animation is conditional on the window's innerWidth (in coordination with the CSS media queries).
        If desktop, stagger the li's via the parent.
        If mobile, the parent stagger is disreviewed, and each li is responsible for its own animation.

        This was done to give that 'each item appears individually' feel.
    */

    const liAnim = {
        hidden: { opacity: 0, left: '100%' },
        visible: { opacity: 1, left: '0%' }
    }

    // One ref and useInView for each education item
    const liRef1 = useRef(null);
    const liInView1 = useInView(liRef1, { once: true });

    const liRef2 = useRef(null);
    const liInView2 = useInView(liRef2, { once: true });

    const liRef3 = useRef(null);
    const liInView3 = useInView(liRef3, { once: true });

    const liRef4 = useRef(null);
    const liInView4 = useInView(liRef4, { once: true });

    const liRef5 = useRef(null);
    const liInView5 = useInView(liRef5, { once: true });

    const liRef6 = useRef(null);
    const liInView6 = useInView(liRef6, { once: true });

    const liRefArr = [
        { ref: liRef1, inView: liInView1 },
        { ref: liRef2, inView: liInView2 },
        { ref: liRef3, inView: liInView3 },
        { ref: liRef4, inView: liInView4 },
        { ref: liRef5, inView: liInView5 },
        { ref: liRef6, inView: liInView6 }
    ];

    // One ref and useInView for each education item
    const ulRef = useRef(null);
    const ulInView = useInView(ulRef, { once: true })

    return (
        <Slide color="var(--brand-2);" height="auto" freeHeightBreakpoint="980px">

            <Container>

                <SectionHeader title="Reviews" id="reviews-section" />

                <div id='reviews-container'>

                    <h3>
                        What do our clients say about our work?
                    </h3>

                    {/* <p>
                        From bold tilework to clean modern vanities, we blend design and craftsmanship for a finish that
                        feels premium and lasts.
                    </p> */}

                    <div class="reviews">
                        <article class="review">
                            <img className='quote-img' src={QuoteIcon} />
                            <ul className='star-list'>

                                <li className='star'></li>
                                <li className='star'></li>
                                <li className='star'></li>
                                <li className='star'></li>
                                <li className='star'></li>

                            </ul>

                            <p class="quote-text">
                                Junior delivered excellent quality tile work for my master bathroom. 100% recommend!
                            </p>

                            <div className='profile-container'>
                                <img className='profile-pic' src={JonCramer} />
                                <h3 className='profile-name'> Jon Cramer </h3>
                            </div>
                        </article>

                        <article class="review">
                            <img className='quote-img' src={QuoteIcon} />
                            <ul className='star-list'>

                                <li className='star'></li>
                                <li className='star'></li>
                                <li className='star'></li>
                                <li className='star'></li>
                                <li className='star'></li>

                            </ul>

                            <p class="quote-text">
                                Very satisfied with how my wood flooring came out in living room. I couldn't be happier with the results!
                            </p>

                            <div className='profile-container'>
                                <img className='profile-pic' src={ElainWatson} />
                                <h3 className='profile-name'> Elaine Watson </h3>
                            </div>
                        </article>

                        <article class="review">
                            <img className='quote-img' src={QuoteIcon} />
                            <ul className='star-list'>

                                <li className='star'></li>
                                <li className='star'></li>
                                <li className='star'></li>
                                <li className='star'></li>
                                <li className='star'></li>

                            </ul>

                            <p class="quote-text">
                                The contractor was punctual, knowledgable, and efficient. I'll definitely be contacting them again for my next project.
                            </p>

                            <div className='profile-container'>
                                <img className='profile-pic' src={MykelGroznik} />
                                <h3 className='profile-name'> Mykel Groznik </h3>
                            </div>
                        </article>
                    </div>

                    <AccentLine width="150px" color='var(--white)' />
                    <AccentLine width="75px" color='var(--white)' />

                </div>

            </Container>

        </Slide>
    )
}